/**
 * @generated SignedSource<<ff9047242e985b97c04d6ccf601b230e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LoginInput = {
  clientMutationId?: string | null | undefined;
  email: string;
  password: string;
};
export type LoginPrompt_LoginMutation$variables = {
  input: LoginInput;
};
export type LoginPrompt_LoginMutation$data = {
  readonly Auth: {
    readonly login: {
      readonly jwtTokens: {
        readonly accessToken: string;
        readonly refreshToken: string;
      };
    } | null | undefined;
  };
};
export type LoginPrompt_LoginMutation = {
  response: LoginPrompt_LoginMutation$data;
  variables: LoginPrompt_LoginMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AuthMutations",
    "kind": "LinkedField",
    "name": "Auth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "LoginPayload",
        "kind": "LinkedField",
        "name": "login",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JwtLoginInformation",
            "kind": "LinkedField",
            "name": "jwtTokens",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accessToken",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "refreshToken",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginPrompt_LoginMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LoginPrompt_LoginMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5577302120d88813f01a2eb24b1b9431",
    "id": null,
    "metadata": {},
    "name": "LoginPrompt_LoginMutation",
    "operationKind": "mutation",
    "text": "mutation LoginPrompt_LoginMutation(\n  $input: LoginInput!\n) {\n  Auth {\n    login(input: $input) {\n      jwtTokens {\n        accessToken\n        refreshToken\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "42eb4835bd2da24d525f69315485eda6";

export default node;
